<template>
	<div>
		<myheader :headTitle="headertitle"></myheader>
		<div class="header_extend_main" style="padding-bottom: .5rem;">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div class="text14 textcolor333" style="line-height: 1rem; white-space: pre-wrap">{{content}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	export default {
		data() {
			return {
				headertitle: '推介消息',
				title: '',
				content: '',
				content1: '如何快速进行企业验证\r\n操作入口1：首页企业认证引导栏，点击【去认证】\r\n操作入口2：点击【企业管理】—⊕加号，选择认证企业菜单进入\r\n企业认证分为2个步骤：①组织信息核验——②企业信息认证\r\n①	组织信息核验\r\n选择组织类型：企业、其他；\r\n上传企业营业执照、法定代表人身份证；\r\n填写企业名称、统一社会信用代码、营业执照有效期、法定代表人姓名、法人身份证号；\r\n点击【同意并继续】，信息核验通过后进入企业信息认证页面。\r\n②	企业信息认证\r\n企业信息认证支持2种认证方式：法定代表人认证、法人授权认证\r\n1.	法定代表人认证（适用法人本人进行操作）\r\n选择法人身份验证方式：人脸认证、手机号认证；\r\n验证通过即可完成企业认证。\r\n2.	法人授权认证（适用经法人授权的企业管理员进行操作）\r\n准备事项：\r\n1）	法人授权书（需下载并使用平台提供的授权书模版）；\r\n2）	对公账户打款（需使用企业对公账户向平台对公账户打款1分钱）\r\n上传法定代表人授权书后点击【提交】，等待第三方认证机构审核通过即可完成企业认证。',
				content2: '如何设置个人电子签名\r\n操作入口1：首页点击签名管理\r\n操作入口2：我的页面-个人签名\r\n石化e签平台提供三种签名添加方式：手写签名、上传图片签名、系统生成签名\r\n手写签名支持用户手写方式添加签名；\r\n上传图片签名支持用户上传本地签名图片方式添加签名；\r\n系统生成签名支持系统根据用户选择的字体自动生成标准的签名；',
				type: '1', //true消息  false公告
			};
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				this.type = this.$route.query.type
				switch (this.type) {
					case '1':
						this.content = this.content1
						//this.headertitle = '企业认证'
						break;
					case '2':
						this.content = this.content2
						//this.headertitle = '个人签名'
						break;
				}
			},
		}
	};
</script>


<style scoped lang="scss">
	@import "../../styles/global.css";
</style>